export default (i18n, toastr) => {
  return (res) => {
    if (!res?.config) return;

    const { config, data } = res;

    // Success handling goes here
    // toastr.s(i18n.t('addon-updated-user'));

    return res;
  };
};
